export const MAIN_CONTENT_ID = "main-content";
export const MAIN_CONTENT_HREF = `#${MAIN_CONTENT_ID}`;
